/* eslint-disable @typescript-eslint/no-misused-promises */
import { isProd } from '@/constants'
import Everpay, { ChainType } from '@/libs/everpay-js'
import { handleErrorMsg } from '../util'
import { GenEverpayParams } from '@/libs/chainLibAdaptor/interface'
import chainLibAdaptor from '@/libs/chainLibAdaptor'
import { InitAccountAndEverpayAsyncParams, InitAndHandleEventsParams } from './interface'
import { ConnectAppName, State } from '@/store/state'
import { Store } from 'vuex'

let everpay = new Everpay({ debug: !isProd })

const setEverpay = (chainType: ChainType, params: GenEverpayParams): void => {
  const { account } = params
  if (account === '') {
    everpay = new Everpay({
      account,
      chainType,
      debug: !isProd
    })
  } else {
    everpay = chainLibAdaptor.genEverpay(chainType, params)
  }
}

export const getEverpay = (): Everpay => everpay

const initAccountAndEverpayAsync = async (params: InitAccountAndEverpayAsyncParams): Promise<void> => {
  const { userOperateCausedNoAccounts, store, t, accChainType } = params
  const connectAppName = store.state.connectAppName
  let account = ''
  try {
    // 先更新 accChainType，来标识 充值、提现页面的 Token 筛选
    store.commit('updateAccChainType', accChainType) // 钱包类型
    account = await chainLibAdaptor.getAccountAsync(accChainType, { connectAppName, userOperateCausedNoAccounts, chainType: accChainType })
    setEverpay(accChainType, { connectAppName, account })
    store.commit('updateAccount', account)
    store.commit('updateConnectAppName', connectAppName)
    store.commit('updateConnectingModalVisible', false)
  } catch (e) {
    await store.dispatch('resetAccount')
    store.commit('updateConnectingModalVisible', false)
    handleErrorMsg(e, t)
  }

  try {
    if (account !== '' && account !== null && account !== undefined) {
      store.dispatch('updateEverpayBalancesAsync').then(() => {}).catch(() => {})
      store.dispatch('updateChainBalancesAsync').then(() => {}).catch(() => {})
    }
  } catch (e) {
    handleErrorMsg(e, t)
  }
}

// 连接、更新余额、绑定 chain 相关事件
export const initAndHandleEvents = async (params: InitAndHandleEventsParams): Promise<void> => {
  const { store, t, accChainType } = params
  await initAccountAndEverpayAsync({
    accChainType,
    userOperateCausedNoAccounts: false,
    store,
    t
  })
  chainLibAdaptor.handleChainEvents(accChainType, {
    store,
    handleChainEventsCallback: async (userOperateCausedNoAccounts) => {
      await initAccountAndEverpayAsync({
        accChainType,
        userOperateCausedNoAccounts,
        store,
        t
      })
    }
  })
}

export const disconnectWebsite = async (store: Store<State>): Promise<void> => {
  const { accChainType, connectAppName } = store.state
  chainLibAdaptor.disconnect(accChainType, connectAppName)
  setEverpay(ChainType.ethereum, {
    account: '',
    connectAppName: ConnectAppName.MetaMask
  })
  await store.dispatch('resetAccount')
}
